<template>
  <layout>
    <rdkm-title>
      {{ $t('Акции') }}
      <router-link tag="span" to="/entryActions/add">
        <b-button class="float-right" right size="sm" variant="primary">
            <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
        </b-button>
      </router-link>
    </rdkm-title>
    <div class="tile">   
      <filter-form :name="query.name" v-on:search="$refs.grid.filter($event, true)"></filter-form>   
      <rdkm-grid ref="grid" :state="query" :url-prefix="'pmdd'">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>        
        <grid-column name="name" :title="$t('Название')"></grid-column>                     
        <grid-column name="DELETE" :urlPrefix="'pmdd'" cell="delete-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";
import FilterForm from "./Filter.vue";

export default {
  name: "CityPromo",
  props: ["query"],
  components: {
    "filter-form": FilterForm, 
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>